// utils/tokenUtils.js
import Cookies from "js-cookie";
import { useUserStore } from "@/stores/userStore";

/**
 * Shared token refresh logic that can be used by both router guards and API interceptors
 * @param {number} refreshThresholdMinutes - Minutes before expiry to trigger refresh
 * @returns {Promise<{success: boolean, data?: any, error?: string}>}
 */
export async function performTokenRefresh(refreshThresholdMinutes = 10) {
  try {
    const currentTime = Date.now();
    const expireTimeMs = parseInt(Cookies.get("expireTime"), 10);
    const refreshToken = Cookies.get("refreshToken");

    if (!refreshToken) {
      return { success: false, error: "No refresh token found" };
    }

    // Skip refresh if token still valid beyond threshold
    if (expireTimeMs) {
      const timeUntilExpiry = expireTimeMs - currentTime;
      const thresholdMs = refreshThresholdMinutes * 60 * 1000;
      if (timeUntilExpiry > thresholdMs) {
        return { success: true, data: "token_still_valid" };
      }
    }

    // Use store’s built-in refresh function
    const userStore = useUserStore();
    const payload = { refresh: refreshToken };

    const response = await userStore.refreshUserToken(payload);

    if (response?.success || response?.data) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: "Failed to refresh token" };
    }
  } catch (error) {
    console.error("[TOKEN UTILS] Refresh failed:", error);
    return { success: false, error: error.message };
  }
}

/**
 * Clear all authentication tokens
 */
export function clearAuthTokens() {
  Cookies.remove("refreshToken");
  Cookies.remove("expireTime");
  Cookies.remove("loginTime");
  Cookies.remove("loginResponse");
}
